import React, { Component } from 'react'
import './faq.scss'

class FAQ extends Component {

    constructor(props) {
        super(props);
        this.state = { show: false }
    }

    questionClicked = () => {
        this.setState({show: !this.state.show});
    }

    render() {
        return(
            <div className={"faq " + (this.state.show ? "faq--opened" : "")}>
                <div className="faq__question" onClick={this.questionClicked}>
                    <table>
                        <tbody>
                            <tr>
                                <td><i className={"faq__icon " + this.props.faClass}></i></td>
                                <td className="col"><span className="faq__question-text">{this.props.question}</span></td>
                                <td><i className="fas fa-angle-down faq__caret"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="faq__inner"><div className="faq__answer">{this.props.answer}</div></div>
            </div>
        );
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/components/FAQ/FAQ.js